import { isPresent } from '@ember/utils';
export const IMAGE_ORIGIN_TO_FASTLY_MAPPING = {
  'square-postoffice-staging.s3.amazonaws.com': 'postoffice-staging-f.squarecdn.com',
  'square-postoffice-production.s3.amazonaws.com': 'postoffice-production-f.squarecdn.com',
  'square-postoffice-production.s3.us-west-1.amazonaws.com': 'postoffice-production-f.squarecdn.com',
  'square-staging.s3.amazonaws.com': 'square-web-staging-f.squarecdn.com',
  'd1g145x70srn7h.cloudfront.net': 'square-web-production-f.squarecdn.com',
  'square-production.s3.amazonaws.com': 'square-web-production-f.squarecdn.com',
  'square-outreach-emails.s3.amazonaws.com': 'squareoutreach-production-f.squarecdn.com',
  'items-images-staging.s3.us-west-2.amazonaws.com': 'items-images-staging-f.squarecdn.com',
  'items-images-production.s3.us-west-2.amazonaws.com': 'items-images-production-f.squarecdn.com',
  'square-receipts-staging.s3.amazonaws.com': 'receipts-staging-f.squarecdn.com',
  'square-receipts-production.s3.amazonaws.com': 'receipts-production-f.squarecdn.com',
  'd3g64w74of3jgu.cloudfront.net': 'receipts-production-f.squarecdn.com',
  'square-store-staging.s3.amazonaws.com': 'beanstalk-staging-f.squarecdn.com',
  'square-store-production.s3.amazonaws.com': 'beanstalk-production-f.squarecdn.com',
  'square-web-sandbox.s3.amazonaws.com': 'square-web-sandbox-f.squarecdn.com',
  // NB: Merchant images from roster-rails are using fastly image domain but they
  // need to be converted to Fastly IO for image resizing. So both key and values are the same for
  // for the following Fastly domains.
  'square-web-staging-f.squarecdn.com': 'square-web-staging-f.squarecdn.com',
  'square-web-production-f.squarecdn.com': 'square-web-production-f.squarecdn.com',
  'square-web-sandbox-f.squarecdn.com': 'square-web-sandbox-f.squarecdn.com',
  'square-catalog-sandbox.s3.amazonaws.com': 'items-images-sandbox-f.squarecdn.com',
  'dashboard-production-f.squarecdn.com': 'dashboard-production-f.squarecdn.com',
  'appointments-staging.s3.amazonaws.com': 'appointments-staging-f.squarecdn.com',
  'appointments-production.s3.amazonaws.com': 'appointments-production-f.squarecdn.com'
};

/**
 * Get a fastly url with the configuration passed in.
 * See https://developer.fastly.com/reference/io/ for more information
 * @param {String} imageSrc - url of the image
 * @param {Object} configuration - set of parameters added to the faslty url
 * @returns a fastly string url
 */

export const fastlyMocks = {
  getFastlyUrl(imageSrc, {
    width,
    height,
    fit
  } = {}) {
    const url = new URL(imageSrc);
    const domain = url.hostname;
    let fastlyUrl = '';

    // look up the fastly domain associated with the image origin and replace it with the fastly domain
    const fastlyDomain = IMAGE_ORIGIN_TO_FASTLY_MAPPING[domain];
    if (isPresent(fastlyDomain)) {
      const newUrl = imageSrc.replace(domain, fastlyDomain);
      const newUrlObject = new URL(newUrl);
      const newUrlParams = newUrlObject.searchParams;
      if (width) {
        newUrlParams.append('width', width.toString());
      }
      if (height) {
        newUrlParams.append('height', height.toString());
      }
      if (fit) {
        newUrlParams.append('fit', fit);
      }
      newUrlParams.append('enable', 'upscale');
      newUrlObject.search = newUrlParams.toString();
      fastlyUrl = newUrlObject.toString();
    }
    return fastlyUrl;
  }
};
export function getFastlyUrl(imageSrc, {
  width,
  height,
  fit
} = {}) {
  return fastlyMocks.getFastlyUrl(imageSrc, {
    width,
    height,
    fit
  });
}